module.exports = __webpack_public_path__ + "img/395.0cfb3aed.png";